var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
const REFRESH_KEY_PREFIX = 'lazy_chunk_reload';
function retryImport(factory, retries, delayMs) {
    return __awaiter(this, void 0, void 0, function* () {
        for (let attempt = 0; attempt <= retries; attempt++) {
            try {
                return yield factory();
            }
            catch (err) {
                if (attempt === retries)
                    throw err;
                yield new Promise(r => setTimeout(r, delayMs * (attempt + 1)));
            }
        }
        throw new Error('unreachable');
    });
}
function isChunkError(error) {
    if (!(error instanceof Error))
        return false;
    return (error.name === 'ChunkLoadError' ||
        error.message.includes('Loading chunk') ||
        error.message.includes('Loading CSS chunk') ||
        error.message.includes('Unexpected token'));
}
function loadChunk(factory, chunkKey) {
    return __awaiter(this, void 0, void 0, function* () {
        const storageKey = `${REFRESH_KEY_PREFIX}_${chunkKey}`;
        try {
            const result = yield retryImport(factory, 2, 300);
            sessionStorage.removeItem(storageKey);
            return result;
        }
        catch (error) {
            if (isChunkError(error) && !sessionStorage.getItem(storageKey)) {
                sessionStorage.setItem(storageKey, '1');
                window.location.reload();
                return new Promise(() => { });
            }
            throw error;
        }
    });
}
export function lazyWithRetry(factory, chunkKey) {
    return React.lazy(() => loadChunk(factory, chunkKey));
}
